const detailsToggles = [...document.querySelectorAll('.js-toggleDetails')];
const detailsBlocks = [...document.querySelectorAll('.js-group')];
detailsToggles.map(detailsToggle => {
    detailsToggle.addEventListener('click', function() {
        const details = document.getElementById(detailsToggle.dataset.details);

        detailsBlocks.map(detailsBlock => {
            if(detailsBlock !== details) {
                detailsBlock.open = false;
                const toggle = document.querySelector(`[data-details="${detailsBlock.id}"]`);
                if (toggle) {
                    toggle.classList.remove('active');
                }
            }
        });

        details.open = !details.open;
        detailsToggle.classList.toggle('active', details.open);
    });
});

function openTabByHash(hash) {
    if (!hash) return;
    const target = document.getElementById(hash.replace('#', ''));
    if (!target) return;
    const details = target.querySelector('.js-group') || target.closest('.js-group');
    if (!details) return;

    detailsBlocks.map(detailsBlock => {
        const isTarget = detailsBlock === details;
        detailsBlock.open = isTarget;
        const toggle = document.querySelector(`[data-details="${detailsBlock.id}"]`);
        if (toggle) {
            toggle.classList.toggle('active', isTarget);
        }
    });
}

if (window.location.hash) {
    openTabByHash(window.location.hash);
}